var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    {
      staticClass: "user-avatar-icon",
      attrs: { role: "img", "aria-label": _vm.name },
    },
    [
      _c("span", { staticClass: "user-avatar-icon__initials" }, [
        _vm._v(_vm._s(_vm.initials)),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }